export enum PageModeRequest {
  FIRST,
  NEXT,
  PREVIOUS,
  NEW,
}

export interface KibanaQueryDTO {
  index: string;
  queryConditions: QueryConditionsDTO;
  offset: number;
  perPage: number;
  orderParam?: string;
  orderDirection?: string;
  convertTo?: string;
  indexClass?: string;
  orderParamTieBreaker: string;
  after?: string;
  before?: string;
  last?: boolean;
}

export interface QueryConditionsDTO {
  index: string;
  conditions: QueryConditionDTO[];
}

export interface QueryConditionDTO {
  fieldName: string;
  operand: QueryOperand;
  value: any;
}

export enum QueryOperand {
  EQUALS = 'EQUALS',
  QUERY_STRING = 'QUERY_STRING',
  DATE_RANGE = 'DATE_RANGE',
}
